import React from "react";

const ViewDistributorInfo = ({ data }: any) => {
  const dataKeys = Object.keys(data);
  console.log("Data : ", data);

  return (
    <div className="w-full p-5 bg-white dark:bg-gray-300/10">
      <table className="w-full border border-collapse border-gray-300 rounded-lg">
        <tbody>
          {dataKeys.map((item) => {
            let label = item
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, str => str.toUpperCase());
            // Show 'Distributor Code' instead of 'Customer Code'
            if (item === "customerCode") {
              label = "Distributor Code";
            }
            return (
              <tr key={item} className="border-b">
                <td className="p-3 px-5 font-medium text-gray-600 dark:text-gray-300 ">{label}</td>
                <td className="p-3 text-gray-600 dark:text-gray-300 px-16">{data[item]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ViewDistributorInfo;
